<div class="flex justify-between mb-2" [attr.data-testid]="testIdInfo()">
  <span>{{ label() }}</span>
  <span>{{ completed() }}/{{ total() }}</span>
</div>
<p-progressBar
  [showValue]="false"
  [class]="completed() === total() ? 'completed-progress' : ''"
  [style]="{height: '6px'}"
  [value]="calcPercentage()"
  [attr.data-testid]="testIdBar()"
></p-progressBar>
